import TotalPriceConnector from './totalPrice.props';
import TotalPriceComponent from './totalPrice.component';

export default TotalPriceConnector(TotalPriceComponent);
